<template>
  <main id="app">
    <Cover :name="name" :description="description" />
    <Notification />
    <Coordinates :parties="parties" :guidesVisible="guidesVisible" :terms="terms" />
    <TokenList :parties="parties" :totalParties="totalParties" />
  </main>
</template>

<script>
  import Json from "./config.json";
  import $ from "jquery";
  import Cover from "./components/Cover.vue";
  import Notification from "./components/Notification.vue";
  import TokenList from "./components/TokenList.vue";
  import Coordinates from "./components/Coordinates.vue";
  import EventBus from "./eventBus";
  import _ from "lodash";

  export default {
    name: "App",

    components: {
      Cover,
      Notification,
      TokenList,
      Coordinates,
    },

    data: () => ({
      name: "",
      description: "",
      parties: [],
      totalParties: 0,
      terms: {},
      guidesVisible: false,
    }),

    beforeCreate() {
      EventBus.$on("toggleGuide", () => {
        this.guidesVisible = !this.guidesVisible;
      });

      EventBus.$on("addToken", () => {
        this.totalParties++;
      });

      EventBus.$on("removeToken", (index) => {
        this.parties.splice(index, 1);
        this.clones = $(".clone");
        this.clones.eq(index).remove();
      });
    },

    // when the app is mounted fetch the json
    mounted() {
      this.fetchConfig();
    },

    methods: {
      // fetch config file and populate data
      fetchConfig() {
        this.name = Json.name;
        this.description = Json.description;
        this.parties = Json.parties;
        this.terms = Json.terms[0];
        this.totalParties = _.size(this.parties) + 1;
      },

      // randomize json parties, add the json object as parameter to the function
      randomizeParties(json) {
        const rand_json = json.sort(function () {
          return 0.5 - Math.random();
        });
        return rand_json;
      },
    },
  };
</script>

<style lang="scss">
  @import url("https://fonts.googleapis.com/css?family=Bree+Serif|Fira+Sans:400,500");
  @import "@/scss/01-base/global.scss";
  @import "@/scss/01-base/type.scss";

  #app {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
  }
</style>
